<template>
  <custom-form-item :label="label" label-width="85px" :append-span="12">
    <template>
      <el-form-item label="Align" :prop="prop ? `${prop}.${type}.align`: `${type}.align`" label-width="70px" required>
        <el-radio-group v-model="item.align" size="mini" text-color="#EF767A">
          <el-tooltip
            class="item" effect="dark"
            v-for="opt in alignOption[type]"
            :key="opt.label"
            :content="opt.label"
            placement="top"
          >
            <el-radio-button
              :key="opt.value"
              :label="opt.value"
            >
              <img class="img-align" :src="opt.icon">
            </el-radio-button>
          </el-tooltip>
        </el-radio-group>
      </el-form-item>
    </template>
    <template #append>
      <el-form-item
        label="Padding"
        :prop="prop ? `${prop}.${type}.padding`: `${type}.padding`"
        :rules="numberRule(`${type}_padding`, min, max)"
        label-width="80px"
      >
        <slot name="padding">
          <el-input
            type="number"
            :min="min"
            :max="max"
            v-model.number="item.padding"
            :disabled="item.align === 'center'"
            size="small"
          >
            <template slot="append">
              px</template
            >
          </el-input>
        </slot>
      </el-form-item>
    </template>
  </custom-form-item>
</template>

<script>
import CustomFormItem from "@/components/base/forms/customFormItem.vue";
import MixFormRule from "@/components/mixins/formRule";
export default {
  props: {
    value: { type: Object, default: { align: "center", padding: 0 } },
    label: String,
    prop: String,
    type: {
      type: String,
      required: true,
      default: "vertical",
      validator: (value) => ["vertical", "horizontal"].includes(value),
    },
    min: Number,
    max: Number,
  },
  data() {
    return {
      item: this.value,
      alignOption: {
        vertical: [
          {
            label: "Top",
            value: "top",
            icon: require("@/assets/top.svg")
          },
          {
            label: "Center",
            value: "center",
            icon: require("@/assets/center.svg")
          },
          {
            label: "Bottom",
            value: "bottom",
            icon: require("@/assets/bottom.svg")
          },
        ],
        horizontal: [
          {
            label: "Left",
            value: "left",
            icon: require("@/assets/align-left.svg")
          },
          {
            label: "Center",
            value: "center",
            icon: require("@/assets/align-center.svg")
          },
          {
            label: "Right",
            value: "right",
            icon: require("@/assets/align-right.svg")
          },
        ],
      },
    };
  },
  components: {
    CustomFormItem,
  },
  mixins: [MixFormRule],
  watch: {
    value(newVal) {
      this.item = newVal;
    },
    item(newVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
